<template>
  <div class="new-layout-con">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentObj: {}, //当前路由meta
    };
  },
  watch: {
    $route(to, from) {
      // 在这里处理路由变化时的逻辑
      this.currentObj = to.meta;
      let htmlDom = document.querySelector("html");
      let bodyDom = document.querySelector("body");
      if (bodyDom) {
        if (to.meta.isNewPage) {
          htmlDom.classList.add("html-new-page");
          bodyDom.className = this.currentObj.theme;
        } else {
          htmlDom.classList.remove("html-new-page");
          bodyDom.className = "";
        }
      }
    },
  },
  methods: {},
  mounted() {
    this.currentObj = this.$route.meta;
    let htmlDom = document.querySelector("html");
    let bodyDom = document.querySelector("body");
    if (htmlDom) {
      if (this.$route.meta.isNewPage) {
        htmlDom.classList.add("html-new-page");
        bodyDom.className = this.currentObj.theme;
      } else {
        bodyhtmlDomDom.classList.remove("html-new-page");
        bodyDom.className = "";
      }
    }
  },
};
</script>
